var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroundwaterWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 397.991,
    height: 133.793
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 4",
    d: "M244.556 133.793h-94.675v-.162L0 133.793.055 1.006l159.166-.13v.1l79.518-.091V.862l159.252.04v132.891z",
    fill: "#72c6df",
    opacity: 0.549
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 303",
    fill: "none",
    stroke: "#137ff6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 39",
    d: "M.042 1h238.453"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 41",
    d: "M48.086 6.413h63.608"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 50",
    d: "M285.602 6.413h63.608"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 42",
    d: "M54.853 11.827h50.074"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 49",
    d: "M292.368 11.827h50.074"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 43",
    d: "M61.62 17.24h36.541"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 48",
    d: "M299.135 17.24h36.541"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 44",
    d: "M68.387 22.653h23.007"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 47",
    d: "M305.902 22.653h23.007"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 45",
    d: "M73.8 28.067h12.18"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 46",
    d: "M311.315 28.067h12.18"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 40",
    d: "M238.234 1h159.697"
  })))));
}

export default __webpack_public_path__ + "6ab64ef77f5781d0245f7c0fc4c1707e.svg";
export { SvgGroundwaterWater as ReactComponent };